import { useLoginStore } from "features/login/store";
import { MENU_NAO_ADMIN } from "pages/usuarioRota/acessoPaginas";
import { useMinhasRotas } from "pages/usuarioRota/hooks/useMinhasRotas";
import { useMemo } from "react";
import type { MenuData } from "./types";

export function useGetMenuData(): MenuData[] {
	const empresaIdpk = useLoginStore((s) => s.empresaIdpk);
	const isAdmin = !!useMinhasRotas().data?.isAdmin;

	// biome-ignore lint/correctness/useExhaustiveDependencies: quando a empresa mudar, recalcular o  menu
	const data: MenuData[] = useMemo(
		() => [
			{
				title: "Painel Gerencial",
				key: "painel-gerencial",
				icon: "home",
				url: "/a/painel-gerencial",
			},
			{
				title: "Movimentações",
				key: "movimentacoes",
				children: [
					{
						title: "Coletas",
						key: "coletas",
						url: "/a/coletas",
						icon: "inbox",
					},
					{
						title: "Análises",
						key: "analises",
						url: "/a/analises",
						icon: "columns",
					},
				],
			},
			{
				title: "Financeiro",
				key: "financeiro",
				children: [
					{
						title: "Cálculos",
						key: "calculos",
						url: "/a/calculos",
						icon: "layout",
					},
					{
						title: "Produtor/Notas Fiscais",
						key: "produtorNfe",
						url: "/a/produtor_nfe",
						icon: "file-text",
					},
					{
						title: "Descontos/Convênios",
						key: "convenios",
						url: "/a/convenios",
						icon: "percent",
					},
					{
						title: "Bonificações",
						key: "bonificacoes",
						url: "/a/bonificacoes",
						icon: "award",
						hide: true,
					},
					{
						title: "Preço Referência",
						key: "precoReferencia",
						url: "/a/preco_referencia",
						icon: "tag",
					},
				],
			},
			{
				title: "Coletas",
				key: "coletas-fechamento",
				children: [
					{
						title: "Fechamento",
						key: "fechamento",
						url: "/a/fechamento",
						icon: "lock",
					},
					{
						title: "Gráficos",
						key: "graficos",
						url: "/a/graficos",
						icon: "bar-chart-2",
					},
				],
			},
			{
				title: "Cadastros",
				key: "cadastros",
				children: [
					{
						title: "Rotas",
						key: "rotas",
						url: "/a/rotas",
						icon: "trending-up",
					},
					{
						title: "Sub Rotas",
						key: "sub_rotas",
						url: "/a/sub_rotas",
						icon: "trending-down",
					},
					{
						title: "Usuários x Rotas",
						key: "usuario_rotas",
						url: "/a/usuario_rotas",
						icon: "users",
						hide: !isAdmin,
					},
					{
						title: "Produtores",
						key: "produtores",
						url: "/a/produtores",
						icon: "truck",
					},
					{
						title: "Propriedades",
						key: "propriedades",
						url: "/a/propriedade",
						icon: "home",
					},
					{
						title: "Motoristas",
						key: "motoristas",
						url: "/a/motorista",
						icon: "user",
					},
					{
						title: "Veiculos",
						key: "veiculos",
						url: "/a/veiculo",
						icon: "target",
					},
					{
						title: "Empresas Conveniadas",
						key: "empresasConveniadas",
						url: "/a/empresas_conveniadas",
						icon: "database",
					},
					{
						title: "Referências",
						key: "referencias",
						url: "/a/referencias",
						icon: "package",
					},
				],
			},
			{
				title: "Relatórios",
				key: "relatorios",
				children: [
					{
						title: "Produtor Simples",
						key: "relatorios-cadastro-produtor-simp",
						url: "/a/relatorios/cadastro-produtor-simp",
						icon: "trello",
					},
					{
						title: "Produtor",
						key: "relatorios-cadastro-produtor",
						url: "/a/relatorios/cadastro-produtor",
						icon: "table",
					},
					{
						title: "Coletas por Cidade",
						key: "relatorios-coletas-cidade",
						url: "/a/relatorios/coletas-cidade",
						icon: "map",
					},
					{
						title: "Entrada Leite",
						key: "relatorios-entrada-leite",
						url: "/a/relatorios/entrada-leite",
						icon: "shuffle",
					},
					{
						title: "Ficha Produtor",
						key: "relatorios-ficha-produtor",
						url: "/a/relatorios/ficha-produtor",
						icon: "list",
					},
					{
						title: "Financeiro Produtor",
						key: "relatorios-financeiro-produtor",
						url: "/a/relatorios/financeiro-produtor",
						icon: "dollar-sign",
					},
					{
						title: "Pagamento Produtor",
						key: "relatorios-pagamento-produtor",
						url: "/a/relatorios/pagamento-produtor",
						icon: "dollar-sign",
					},
					{
						title: "Funrural",
						key: "relatorios-funrural",
						url: "/a/relatorios/funrural",
						icon: "filter",
					},
					{
						title: "Lançamentos",
						key: "relatorios-lancamentos",
						url: "/a/relatorios/lancamentos",
						icon: "calendar",
					},
					{
						title: "Litragem Coleta",
						key: "relatorios-litragem-coleta",
						url: "/a/relatorios/litragem-coleta",
						icon: "circle",
					},
					{
						title: "Litragem Mensal",
						key: "relatorios-litragem-mensal",
						url: "/a/relatorios/litragem-mensal",
						icon: "disc",
					},
					{
						title: "Leituras fora do padrão",
						key: "relatorios-leituras-fora-padrao",
						url: "/a/relatorios/leituras-fora-padrao",
						icon: "calendar",
					},
					{
						title: "Produtor Faixa Litragem",
						key: "relatorios-produtor-faixa-litragem",
						url: "/a/relatorios/produtor-faixa-litragem",
						icon: "calendar",
					},
					{
						title: "Análise de Qualidade",
						key: "relatorios-analise-qualidade",
						url: "/a/relatorios/analise-qualidade",
						icon: "activity",
					},
					{
						title: "Referência",
						key: "relatorios-referencia",
						url: "/a/relatorios/referencia",
						icon: "droplet",
					},
				],
			},
		],
		[empresaIdpk, isAdmin],
	);

	// Usuário não administrador vê só a seção "Coletas" (Fechamento e Gráficos)
	return isAdmin ? data : data.filter((item) => item.key === MENU_NAO_ADMIN);
}
